module.exports = __webpack_public_path__ + "img/flyer_08.308d8064.jpeg";